import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import MapView from '@arcgis/core/views/MapView';
import { Tool, ToolSlot } from '../framework/Tool';
import { SurfaceDef } from '../model/SurfaceDef';
import { NewBreaklineInputTask } from './NewBreaklineInputTask';

export class AddBreaklineTool extends Tool {
  private readonly mapView: MapView;
  private readonly surfaceDef: SurfaceDef;
  private task: NewBreaklineInputTask;
  private breaklinesLayer: GraphicsLayer;

  constructor(mapView: MapView, surfaceDef: SurfaceDef, toolSlot: ToolSlot, breaklinesLayer: GraphicsLayer) {
    super('Add Breakline', 'single', toolSlot);
    this.mapView = mapView;
    this.surfaceDef = surfaceDef;
    this.task = new NewBreaklineInputTask(this.mapView, this.surfaceDef);
    this.breaklinesLayer = breaklinesLayer;
  }

  protected async onExecuteOperation(): Promise<void> {
    const result = await this.task.executeTaskAsync();

    this.surfaceDef.breaklinesSyncSet.insertItem(result);
    //console.log('Add breaklines1: ', this.surfaceDef.breaklinesSyncSet.getItems());
    //redraw layer
    const graphic = result.generateGraphic(this.mapView.spatialReference);
    this.breaklinesLayer.add(graphic);

    return;
  }

  protected async onCancelOperation(): Promise<void> {
    if (this.task.isExecuting) {
      await this.task.cancelTaskAsync();
    }
    return;
  }

  public generateBreaklinesByDescription(description: string, isClosed: boolean): string[] {
    this.onCancelOperation();
    if (!description) {
      return [];
    }

    //check breaklines if it already exists
    const graphicsToRemove = this.breaklinesLayer.graphics.filter(graphic => {
      return graphic.attributes?.description === description;
    }).toArray();

    // Remove specific breaklines for the selected description
    this.breaklinesLayer.removeMany(graphicsToRemove);

    // Loop through and remove each breakline from syncSet before deleting it
    graphicsToRemove.forEach((g) => {
      this.surfaceDef.breaklinesSyncSet.deleteItem(g.attributes, true);
    });

    const { breakline, messages } = this.task.setUpGenerateBreakLine(description, isClosed, this.breaklinesLayer);
    if (!breakline) {
      return messages;
    }

    if (breakline && messages?.length > 0) {
      const [type] = messages[0].split(":");
      if (type === "Error") return messages;
    }

    this.surfaceDef.breaklinesSyncSet.insertItem(breakline);
    const graphic = breakline.generateGraphic(this.mapView.spatialReference);
    graphic.attributes["description"] = description;  //add desc attribute, so that it helps future removal
    this.breaklinesLayer.add(graphic);
    return messages;
  }

  public redraw(){
    this.breaklinesLayer.removeAll();
    for (const breakline of this.surfaceDef!.breaklinesSyncSet.getItems()) {
      const graphic = breakline.generateGraphic(this.mapView.spatialReference);
      this.breaklinesLayer.add(graphic);
    }
  }
  public clear(){
    this.breaklinesLayer.removeAll();
  }
}
